
import React from 'react';
import { Box, ResponsiveContext } from 'grommet';
import { withTheme } from 'styled-components';

import PageHeader from './PageHeader';

const Page = ({theme, children, ...props}) => {
    return (
        <ResponsiveContext.Consumer>
            {size => (
                <Box fill={true}>
                    <PageHeader/>
                    <Box height="100%">
                        {children}
                    </Box>
                </Box>
            )}
        </ResponsiveContext.Consumer>
    );
};

export default withTheme(Page);
